module.exports = __webpack_public_path__ + "statics/img/cate9-5@2x.ea4c297b.png";